import { useLocation, useParams } from "react-router-dom";
import { ConfiguratorContext } from "../Configurator.context";

export type Step = {
  sortOrder: number;
  hasSubSteps?: boolean;
  getDisabledReasons?: (state: ConfiguratorContext) => string[] | null;
};

/**
 * Flow steps match the `Community` / `Lot` / `Plan` steps on the top of the header.
 *
 * I.e. we don't care about sub-steps of "Options has both Structural & Add-On substeps".
 */
export enum FlowStep {
  Community = "community",
  Lot = "lot",
  Plans = "plan",
  Exterior = "exterior",
  Structural = "structural",
  Interior = "interior",
  Options = "options",
  Adu = "adu",
  Summary = "summary",
}

export const FlowSteps: Record<FlowStep, Step> = {
  [FlowStep.Community]: {
    sortOrder: 1,
    getDisabledReasons: (contextState) => {
      if (!contextState.communityId) return ["Please select a community"];
      return null;
    },
  },
  [FlowStep.Lot]: {
    sortOrder: 2,
    getDisabledReasons: (contextState) => {
      if (!contextState.lotId) return ["Please select a lot"];
      return null;
    },
  },
  [FlowStep.Plans]: {
    sortOrder: 3,
  },
  [FlowStep.Exterior]: {
    sortOrder: 4,
  },
  [FlowStep.Structural]: {
    sortOrder: 5,
  },
  [FlowStep.Interior]: {
    sortOrder: 6,
    hasSubSteps: true,
  },
  [FlowStep.Options]: {
    sortOrder: 7,
  },
  [FlowStep.Adu]: {
    sortOrder: 8,
  },
  [FlowStep.Summary]: {
    sortOrder: 9,
  },
};

/** Reads either the `step` URL param then handles special cases like the `communities` and `lots`. */
export function useStepFromLocation(): FlowStep {
  const stepFromParam = useParams().step as FlowStep | undefined;
  const location = useLocation();

  if (stepFromParam) return stepFromParam;

  const step = location.pathname.split("/").pop();
  if (step === "communities") return FlowStep.Community;
  if (step === "lots") return FlowStep.Lot;

  return FlowStep.Plans;
}
